import { z } from "zod";
import {
  isEmailFormatValid,
  isCharacterTypeValid,
} from "@root/userFrontend/features/registration/schemas/step1/validation";

export const schema = z.object({
  email: z
    .string()
    .min(1, { message: "必須です" })
    .refine((val) => isEmailFormatValid(val), {
      message: "メールアドレスを正しく入力してください",
    }),
  password: z
    .string()
    .min(1, { message: "必須です" })
    .refine((val) => z.string().min(8).safeParse(val).success || isCharacterTypeValid(val), {
      message: "大文字、小文字、数字、記号の2種類以上を使用し、8文字以上入力してください",
    })
    .refine((val) => isCharacterTypeValid(val), {
      message: "大文字、小文字、数字、記号の2種類以上を使用してください",
    })
    .min(8, { message: "8文字以上入力してください" }),
});

export type FormValues = z.output<typeof schema>;
